<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="ngung-cong-tac-sidebar"
    :visible="isShowSidebar"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-esc
    no-close-on-backdrop
    @hidden="resetForm"
    @change="(val) => $emit('update:is-show-sidebar', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Thông tin ngừng công tác</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Ngày ký quyết định"
                rules="required"
              >
                <b-form-group
                  label="Ngày ký quyết định"
                  label-for="ngayKyQuyetDinh"
                  :state="getValidationState(validationContext)"
                >
                  <flat-pickr
                    v-model="formData.ngayKyQuyetDinh"
                    class="form-control"
                    placeholder="__/__/____"
                    :config="{
                      wrap: true,
                      allowInput: true,
                      dateFormat: 'Y-m-d',
                      altInput: true,
                      altFormat: 'd/m/Y',
                    }"
                  />
                  <!-- <b-form-datepicker
                    id="ngayKyQuyetDinh"
                    v-model="formData.ngayKyQuyetDinh"
                    :state="getValidationState(validationContext)"
                    :disabled="isWait"
                    placeholder="__/__/____"
                    locale="vi"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                  /> -->

                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Ngày hiệu lực"
                rules="required"
              >
                <b-form-group
                  label="Ngày hiệu lực"
                  label-for="ngay"
                  :state="getValidationState(validationContext)"
                >
                  <!-- <b-form-datepicker
                    id="ngay"
                    v-model="formData.ngay"
                    :state="getValidationState(validationContext)"
                    :disabled="isWait"
                    placeholder="__/__/____"
                    locale="vi"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                  /> -->
                  <flat-pickr
                    v-model="formData.ngay"
                    class="form-control"
                    placeholder="__/__/____"
                    :config="{
                      wrap: true,
                      allowInput: true,
                      dateFormat: 'Y-m-d',
                      altInput: true,
                      altFormat: 'd/m/Y',
                    }"
                  />

                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Số quyết định"
                rules=""
              >
                <b-form-group label="Số quyết định" label-for="soKyQuyetDinh">
                  <b-form-input
                    class="form-el"
                    id="soKyQuyetDinh"
                    v-model="formData.soKyQuyetDinh"
                    :state="getValidationState(validationContext)"
                    :disabled="isWait"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Người ký"
                rules=""
              >
                <b-form-group label="Người ký" label-for="nguoiKy">
                  <b-form-input
                    class="form-el"
                    id="nguoiKy"
                    v-model="formData.nguoiKy"
                    :state="getValidationState(validationContext)"
                    :disabled="isWait"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="validationContext"
                name="Lý do"
                rules="required"
              >
                <b-form-group
                  label="Lý do"
                  label-for="trangThai"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.trangThai"
                    :reduce="(val) => val"
                    :options="DM_NGHIVIEC"
                    label="name"
                    :disabled="isWait"
                    :clearable="false"
                    input-id="lyDo"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="validationContext"
                name="Ghi chú"
                rules=""
              >
                <b-form-group label="Ghi chú" label-for="ghiChu">
                  <b-form-input
                    class="form-el"
                    id="ghiChu"
                    v-model="formData.ghiChu"
                    :state="getValidationState(validationContext)"
                    :disabled="isWait"
                    placeholder=""
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <b-form-group label="Tệp tin" label-for="tepTin">
                <div
                  v-if="formData.file.length > 0"
                  v-for="file in formData.file"
                  class="d-flex justify-content-between"
                >
                  <b-link
                    class="ml-25"
                    :href="`${urlFile}/files/view/${file.fileId}`"
                    target="_blank"
                    >{{ file.fileName }}</b-link
                  >
                  <b-button
                    variant="flat-danger"
                    class="btn-icon"
                    @click="deleteFile(file.fileId)"
                  >
                    <feather-icon icon="TrashIcon" size="18" />
                  </b-button>
                </div>
                <vue-dropzone
                  ref="myVueDropzone"
                  id="dropzone"
                  :use-custom-slot="true"
                  :options="dropzoneOptions"
                  v-on:vdropzone-removed-file="removeThisFile"
                  v-on:vdropzone-sending="sendingEvent"
                  v-on:vdropzone-success="UploadFile"
                >
                  <div class="dropzone-custom-content">
                    <feather-icon
                      icon="DownloadCloudIcon"
                      size="3x"
                      class="mb-2"
                    />
                    <h5>Kéo thả hoặc bấm vào để tải tệp tin</h5>
                  </div></vue-dropzone
                >
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <div class="d-flex mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2"
                  :disabled="isWait"
                  type="submit"
                >
                  Lưu
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="button"
                  variant="outline-secondary"
                  :disabled="isWait"
                  @click="rollbackFiles"
                >
                  Đóng
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable */
import {
  BLink,
  BRow,
  BCol,
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormDatepicker,
  BFormCheckbox,
} from "bootstrap-vue";
import vueDropzone from "vue2-dropzone";
import { importFileType } from "@/enums/fileType";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email, url } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ref, computed, watch } from "@vue/composition-api";
import { CanBoCongChucUpdateNghiViec as UpdateNghiViec } from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";
import { DeleteListFile } from "@/services/api/HoSoCanBoCongChuc/FileService";
import flatPickr from "vue-flatpickr-component";
import flatpickr from "flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn.js";
flatpickr.localize(Vietnamese);

export default {
  /* eslint-disable */
  components: {
    vueDropzone,
    BLink,
    BRow,
    BCol,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormDatepicker,
    BFormCheckbox,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  props: {
    cbccvcDetail: {
      type: Object,
      required: true,
    },
    isShowSidebar: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isShowSidebar(val) {
      if (val) {
        this.fnGetNghiViec();
        if (this.cbccvcDetail && this.cbccvcDetail.tinhTrangNghiViec) {
          this.formData.oldId = this.cbccvcDetail.tinhTrangNghiViec.id;
          this.formData.ngay = this.cbccvcDetail.tinhTrangNghiViec.ngay;
          this.formData.trangThai = JSON.parse(
            JSON.stringify(this.cbccvcDetail.tinhTrangNghiViec.trangThai)
          );
          this.formData.ghiChu = this.cbccvcDetail.tinhTrangNghiViec.ghiChu;
          this.formData.ngayKyQuyetDinh =
            this.cbccvcDetail.tinhTrangNghiViec.ngayKyQuyetDinh;
          this.formData.nguoiKy = this.cbccvcDetail.tinhTrangNghiViec.nguoiKy;
          this.formData.file = this.cbccvcDetail.tinhTrangNghiViec.file;
          this.formData.soKyQuyetDinh =
            this.cbccvcDetail.tinhTrangNghiViec.soKyQuyetDinh;
          // if (this.formData.file) this.nowFile = this.formData.file;
        } else {
          // this.nowFile = [];
        }
        this.fileNewUpload = [];
        this.filesDelete = [];
        // else {
        //   this.formData.oldId = "";
        //   this.formData.ngay = "";
        //   this.formData.trangThai = {};
        //   this.formData.ghiChu = "";
        // }
        this.$refs.myVueDropzone.removeAllFiles(true);
      }
    },
  },
  data() {
    return {
      isWait: false,
      formData: {
        oldId: "",
        ngay: "",
        ngayKyQuyetDinh: "",
        trangThai: {},
        ghiChu: "",
        nguoiKy: "",
        file: [],
        soKyQuyetDinh: "",
      },
      nowFile: [],
      fileNewUpload: [],
      filesDelete: [],
      urlFile: process.env.VUE_APP_BASE_API,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_BASE_API}/files/uploadType`,
        thumbnailWidth: 250,
        // maxFiles: 1,
        maxFilesize: 30,
        headers: { "My-Awesome-Header": "header value" },
        // addRemoveLinks: true,
      },
      required,
      alphaNum,
      email,
      url,
      DM_NGHIVIEC: [],
    };
  },
  methods: {
    fnGetNghiViec() {
      this.$store.dispatch("common/fetchNghiViec").then((response) => {
        this.DM_NGHIVIEC = response;
      });
    },
    removeThisFile(file, error, xhr) {
      // console.log("removeThisFile", file, error, xhr);
      let fileRemove = JSON.parse(file.xhr.response);
      if (fileRemove.data && fileRemove.data.id) {
        let idFile = fileRemove.data.id;
        let resultData = this.formData.file.filter((x) => {
          return x.fileId != idFile;
        });
        this.formData.file = resultData;
        console.log("resultData", resultData);
      }
    },
    sendingEvent(file, xhr, formData) {
      this.isWait = true;
      formData.append("idCanBo", this.cbccvcDetail.id);
      formData.append("index", importFileType("NghiViec"));
      this.isWait = false;
    },
    UploadFile(file, response) {
      this.isWait = true;
      this.formData.file = this.formData.file || [];
      this.$refs.myVueDropzone.removeFile(file);
      if (response.code == "SUCCESS") {
        this.formData.file.push({
          fileId: response.data.id,
          fileName: response.data.fileName,
          ext: response.data.ext,
        });
        this.fileNewUpload.push({
          fileId: response.data.id,
          fileName: response.data.fileName,
          ext: response.data.ext,
        });
      } else {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "error",
            text: response.message,
          },
        });
      }

      this.isWait = false;
    },
    deleteFile(val) {
      var index = this.formData.file.findIndex((el) => el.fileId == val);
      if (index != -1) {
        this.filesDelete.push({
          fileId: val,
        });
        this.formData.file.splice(index, 1);
        // this.$refs.myVueDropzone.removeFile(val);
      }
    },
    rollbackFiles() {
      if (this.fileNewUpload && this.fileNewUpload.length > 0) {
        DeleteListFile(this.fileNewUpload);
      }
      this.$emit("update:is-show-sidebar", false);
    },
    async onSubmit() {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        this.isWait = true;
        // if (this.filesDelete && this.filesDelete.length > 0) {
        //   DeleteListFile(this.filesDelete);
        // }
        var res = await UpdateNghiViec({
          id: this.cbccvcDetail.id,
          tinhTrangNghiViec: this.formData,
        });
        this.isWait = false;
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thành công",
              icon: "CheckIcon",
              variant: "success",
              text: res.message,
            },
          });
          this.$emit("update:is-show-sidebar", false);
          this.formData.id = res.data.id;
          this.$emit("update-trang-thai-nghi-viec", this.formData);
        }
      }
    },
  },
  setup() {
    const { refFormObserver, getValidationState, resetForm } = formValidation(
      () => {
        //Reset form
      }
    );
    return {
      // UI
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
